export const INIT_GAME ='INIT_GAME';
export const CREATE_FREE_GAME ='CREATE_FREE_GAME';
